// @ts-check

import BaseModel from "@kaspernj/api-maker/build/base-model.js"
import StripeCoupon from "./stripe-coupon.js"
import StripeCustomer from "./stripe-customer.js"
import StripeSubscription from "./stripe-subscription.js"

const modelClassData = {
  "attributes": {
    "id": {
      "column": {
        "default": null,
        "name": "id",
        "null": false,
        "type": null
      },
      "name": "id",
      "selected_by_default": null,
      "translated": null
    },
    "stripe_coupon_id": {
      "column": {
        "default": null,
        "name": "stripe_coupon_id",
        "null": true,
        "type": "string"
      },
      "name": "stripe_coupon_id",
      "selected_by_default": null,
      "translated": null
    },
    "stripe_customer_id": {
      "column": {
        "default": null,
        "name": "stripe_customer_id",
        "null": true,
        "type": "string"
      },
      "name": "stripe_customer_id",
      "selected_by_default": null,
      "translated": null
    },
    "stripe_subscription_id": {
      "column": {
        "default": null,
        "name": "stripe_subscription_id",
        "null": true,
        "type": "string"
      },
      "name": "stripe_subscription_id",
      "selected_by_default": null,
      "translated": null
    },
    "coupon_amount_off": {
      "column": null,
      "name": "coupon_amount_off",
      "selected_by_default": null,
      "translated": null
    },
    "coupon_currency": {
      "column": {
        "default": null,
        "name": "coupon_currency",
        "null": true,
        "type": "string"
      },
      "name": "coupon_currency",
      "selected_by_default": null,
      "translated": null
    },
    "coupon_duration": {
      "column": {
        "default": null,
        "name": "coupon_duration",
        "null": true,
        "type": "string"
      },
      "name": "coupon_duration",
      "selected_by_default": null,
      "translated": null
    },
    "coupon_duration_in_months": {
      "column": {
        "default": null,
        "name": "coupon_duration_in_months",
        "null": true,
        "type": "integer"
      },
      "name": "coupon_duration_in_months",
      "selected_by_default": null,
      "translated": null
    },
    "coupon_max_redemptions": {
      "column": {
        "default": null,
        "name": "coupon_max_redemptions",
        "null": true,
        "type": "integer"
      },
      "name": "coupon_max_redemptions",
      "selected_by_default": null,
      "translated": null
    },
    "coupon_percent_off": {
      "column": {
        "default": null,
        "name": "coupon_percent_off",
        "null": true,
        "type": "integer"
      },
      "name": "coupon_percent_off",
      "selected_by_default": null,
      "translated": null
    },
    "coupon_redeem_by": {
      "column": {
        "default": null,
        "name": "coupon_redeem_by",
        "null": true,
        "type": "integer"
      },
      "name": "coupon_redeem_by",
      "selected_by_default": null,
      "translated": null
    },
    "coupon_times_redeemed": {
      "column": {
        "default": null,
        "name": "coupon_times_redeemed",
        "null": true,
        "type": "integer"
      },
      "name": "coupon_times_redeemed",
      "selected_by_default": null,
      "translated": null
    },
    "coupon_valid": {
      "column": {
        "default": null,
        "name": "coupon_valid",
        "null": true,
        "type": "boolean"
      },
      "name": "coupon_valid",
      "selected_by_default": null,
      "translated": null
    },
    "created": {
      "column": {
        "default": null,
        "name": "created",
        "null": true,
        "type": "datetime"
      },
      "name": "created",
      "selected_by_default": null,
      "translated": null
    },
    "deleted_at": {
      "column": {
        "default": null,
        "name": "deleted_at",
        "null": true,
        "type": "datetime"
      },
      "name": "deleted_at",
      "selected_by_default": null,
      "translated": null
    },
    "start": {
      "column": {
        "default": null,
        "name": "start",
        "null": true,
        "type": "datetime"
      },
      "name": "start",
      "selected_by_default": null,
      "translated": null
    },
    "end": {
      "column": {
        "default": null,
        "name": "end",
        "null": true,
        "type": "datetime"
      },
      "name": "end",
      "selected_by_default": null,
      "translated": null
    },
    "created_at": {
      "column": {
        "default": null,
        "name": "created_at",
        "null": false,
        "type": "datetime"
      },
      "name": "created_at",
      "selected_by_default": null,
      "translated": null
    },
    "updated_at": {
      "column": {
        "default": null,
        "name": "updated_at",
        "null": false,
        "type": "datetime"
      },
      "name": "updated_at",
      "selected_by_default": null,
      "translated": null
    }
  },
  "className": "StripeDiscount",
  "collectionKey": "stripe_discounts",
  "collectionName": "stripe_discounts",
  "i18nKey": "stripe_discount",
  "camelizedLower": "stripeDiscount",
  "name": "StripeDiscount",
  "nameDasherized": "stripe-discount",
  "pluralName": "stripe_discounts",
  "ransackable_associations": [
    {
      "className": "ActiveRecordAuditable::Audit",
      "collectionName": "audits",
      "foreignKey": "auditable_id",
      "name": "audits",
      "macro": "has_many",
      "resource_name": "Audit",
      "through": null
    },
    {
      "className": "ActiveRecordAuditable::Audit",
      "collectionName": "audits",
      "foreignKey": "auditable_id",
      "name": "create_audit",
      "macro": "has_one",
      "resource_name": "Audit",
      "through": null
    },
    {
      "className": "StripeCoupon",
      "collectionName": "stripe_coupons",
      "foreignKey": "stripe_coupon_id",
      "name": "stripe_coupon",
      "macro": "belongs_to",
      "resource_name": "StripeCoupon",
      "through": null
    },
    {
      "className": "StripeCustomer",
      "collectionName": "stripe_customers",
      "foreignKey": "stripe_customer_id",
      "name": "stripe_customer",
      "macro": "belongs_to",
      "resource_name": "StripeCustomer",
      "through": null
    },
    {
      "className": "StripeDiscount",
      "collectionName": "stripe_discounts",
      "foreignKey": "stripe_discount_id",
      "name": "stripe_discount",
      "macro": "belongs_to",
      "resource_name": "StripeDiscount",
      "through": null
    },
    {
      "className": "StripeInvoice",
      "collectionName": "stripe_invoices",
      "foreignKey": "stripe_discount_id",
      "name": "stripe_invoices",
      "macro": "has_many",
      "resource_name": "StripeInvoice",
      "through": null
    },
    {
      "className": "StripeSubscription",
      "collectionName": "stripe_subscriptions",
      "foreignKey": "stripe_subscription_id",
      "name": "stripe_subscription",
      "macro": "belongs_to",
      "resource_name": "StripeSubscription",
      "through": null
    },
    {
      "className": "StripeSubscription",
      "collectionName": "stripe_subscriptions",
      "foreignKey": "stripe_discount_id",
      "name": "stripe_subscriptions",
      "macro": "has_many",
      "resource_name": "StripeSubscription",
      "through": null
    }
  ],
  "ransackable_attributes": [
    {
      "name": "coupon_amount_off_cents",
      "column": {
        "default": null,
        "name": "coupon_amount_off_cents",
        "null": true,
        "type": "integer"
      }
    },
    {
      "name": "coupon_amount_off_currency",
      "column": {
        "default": null,
        "name": "coupon_amount_off_currency",
        "null": true,
        "type": "string"
      }
    },
    {
      "name": "coupon_created",
      "column": {
        "default": null,
        "name": "coupon_created",
        "null": true,
        "type": "datetime"
      }
    },
    {
      "name": "coupon_currency",
      "column": {
        "default": null,
        "name": "coupon_currency",
        "null": true,
        "type": "string"
      }
    },
    {
      "name": "coupon_duration",
      "column": {
        "default": null,
        "name": "coupon_duration",
        "null": true,
        "type": "string"
      }
    },
    {
      "name": "coupon_duration_in_months",
      "column": {
        "default": null,
        "name": "coupon_duration_in_months",
        "null": true,
        "type": "integer"
      }
    },
    {
      "name": "coupon_livemode",
      "column": {
        "default": null,
        "name": "coupon_livemode",
        "null": true,
        "type": "boolean"
      }
    },
    {
      "name": "coupon_max_redemptions",
      "column": {
        "default": null,
        "name": "coupon_max_redemptions",
        "null": true,
        "type": "integer"
      }
    },
    {
      "name": "coupon_metadata",
      "column": {
        "default": null,
        "name": "coupon_metadata",
        "null": true,
        "type": "text"
      }
    },
    {
      "name": "coupon_percent_off",
      "column": {
        "default": null,
        "name": "coupon_percent_off",
        "null": true,
        "type": "integer"
      }
    },
    {
      "name": "coupon_redeem_by",
      "column": {
        "default": null,
        "name": "coupon_redeem_by",
        "null": true,
        "type": "integer"
      }
    },
    {
      "name": "coupon_times_redeemed",
      "column": {
        "default": null,
        "name": "coupon_times_redeemed",
        "null": true,
        "type": "integer"
      }
    },
    {
      "name": "coupon_valid",
      "column": {
        "default": null,
        "name": "coupon_valid",
        "null": true,
        "type": "boolean"
      }
    },
    {
      "name": "created",
      "column": {
        "default": null,
        "name": "created",
        "null": true,
        "type": "datetime"
      }
    },
    {
      "name": "created_at",
      "column": {
        "default": null,
        "name": "created_at",
        "null": false,
        "type": "datetime"
      }
    },
    {
      "name": "deleted_at",
      "column": {
        "default": null,
        "name": "deleted_at",
        "null": true,
        "type": "datetime"
      }
    },
    {
      "name": "end",
      "column": {
        "default": null,
        "name": "end",
        "null": true,
        "type": "datetime"
      }
    },
    {
      "name": "id",
      "column": {
        "default": null,
        "name": "id",
        "null": false,
        "type": null
      }
    },
    {
      "name": "start",
      "column": {
        "default": null,
        "name": "start",
        "null": true,
        "type": "datetime"
      }
    },
    {
      "name": "stripe_coupon_id",
      "column": {
        "default": null,
        "name": "stripe_coupon_id",
        "null": true,
        "type": "string"
      }
    },
    {
      "name": "stripe_customer_id",
      "column": {
        "default": null,
        "name": "stripe_customer_id",
        "null": true,
        "type": "string"
      }
    },
    {
      "name": "stripe_subscription_id",
      "column": {
        "default": null,
        "name": "stripe_subscription_id",
        "null": true,
        "type": "string"
      }
    },
    {
      "name": "updated_at",
      "column": {
        "default": null,
        "name": "updated_at",
        "null": false,
        "type": "datetime"
      }
    }
  ],
  "ransackable_scopes": [],
  "relationships": [
    {
      "className": "StripeCoupon",
      "collectionName": "stripe_coupons",
      "foreignKey": "stripe_coupon_id",
      "name": "stripe_coupon",
      "macro": "belongs_to",
      "resource_name": "StripeCoupon",
      "through": null
    },
    {
      "className": "StripeCustomer",
      "collectionName": "stripe_customers",
      "foreignKey": "stripe_customer_id",
      "name": "stripe_customer",
      "macro": "belongs_to",
      "resource_name": "StripeCustomer",
      "through": null
    },
    {
      "className": "StripeSubscription",
      "collectionName": "stripe_subscriptions",
      "foreignKey": "stripe_subscription_id",
      "name": "stripe_subscription",
      "macro": "belongs_to",
      "resource_name": "StripeSubscription",
      "through": null
    }
  ],
  "paramKey": "stripe_discount",
  "primaryKey": "id"
}

/** Frontend model for StripeDiscount. */
export default class StripeDiscount extends BaseModel {
  /** @returns {typeof modelClassData} */
  static modelClassData() {
    return modelClassData
  }

  /** @returns {any} */
  id() {
    return this.readAttributeUnderscore("id")
  }

  /** @returns {boolean} */
  hasId() {
    const value = this.id()

    return this._isPresent(value)
  }

  /** @returns {string | null} */
  stripeCouponId() {
    return this.readAttributeUnderscore("stripe_coupon_id")
  }

  /** @returns {boolean} */
  hasStripeCouponId() {
    const value = this.stripeCouponId()

    return this._isPresent(value)
  }

  /** @returns {string | null} */
  stripeCustomerId() {
    return this.readAttributeUnderscore("stripe_customer_id")
  }

  /** @returns {boolean} */
  hasStripeCustomerId() {
    const value = this.stripeCustomerId()

    return this._isPresent(value)
  }

  /** @returns {string | null} */
  stripeSubscriptionId() {
    return this.readAttributeUnderscore("stripe_subscription_id")
  }

  /** @returns {boolean} */
  hasStripeSubscriptionId() {
    const value = this.stripeSubscriptionId()

    return this._isPresent(value)
  }

  /** @returns {any} */
  couponAmountOff() {
    return this.readAttributeUnderscore("coupon_amount_off")
  }

  /** @returns {boolean} */
  hasCouponAmountOff() {
    const value = this.couponAmountOff()

    return this._isPresent(value)
  }

  /** @returns {string | null} */
  couponCurrency() {
    return this.readAttributeUnderscore("coupon_currency")
  }

  /** @returns {boolean} */
  hasCouponCurrency() {
    const value = this.couponCurrency()

    return this._isPresent(value)
  }

  /** @returns {string | null} */
  couponDuration() {
    return this.readAttributeUnderscore("coupon_duration")
  }

  /** @returns {boolean} */
  hasCouponDuration() {
    const value = this.couponDuration()

    return this._isPresent(value)
  }

  /** @returns {number | null} */
  couponDurationInMonths() {
    return this.readAttributeUnderscore("coupon_duration_in_months")
  }

  /** @returns {boolean} */
  hasCouponDurationInMonths() {
    const value = this.couponDurationInMonths()

    return this._isPresent(value)
  }

  /** @returns {number | null} */
  couponMaxRedemptions() {
    return this.readAttributeUnderscore("coupon_max_redemptions")
  }

  /** @returns {boolean} */
  hasCouponMaxRedemptions() {
    const value = this.couponMaxRedemptions()

    return this._isPresent(value)
  }

  /** @returns {number | null} */
  couponPercentOff() {
    return this.readAttributeUnderscore("coupon_percent_off")
  }

  /** @returns {boolean} */
  hasCouponPercentOff() {
    const value = this.couponPercentOff()

    return this._isPresent(value)
  }

  /** @returns {number | null} */
  couponRedeemBy() {
    return this.readAttributeUnderscore("coupon_redeem_by")
  }

  /** @returns {boolean} */
  hasCouponRedeemBy() {
    const value = this.couponRedeemBy()

    return this._isPresent(value)
  }

  /** @returns {number | null} */
  couponTimesRedeemed() {
    return this.readAttributeUnderscore("coupon_times_redeemed")
  }

  /** @returns {boolean} */
  hasCouponTimesRedeemed() {
    const value = this.couponTimesRedeemed()

    return this._isPresent(value)
  }

  /** @returns {boolean | null} */
  couponValid() {
    return this.readAttributeUnderscore("coupon_valid")
  }

  /** @returns {boolean} */
  hasCouponValid() {
    const value = this.couponValid()

    return this._isPresent(value)
  }

  /** @returns {Date | null} */
  created() {
    return this.readAttributeUnderscore("created")
  }

  /** @returns {boolean} */
  hasCreated() {
    const value = this.created()

    return this._isPresent(value)
  }

  /** @returns {Date | null} */
  deletedAt() {
    return this.readAttributeUnderscore("deleted_at")
  }

  /** @returns {boolean} */
  hasDeletedAt() {
    const value = this.deletedAt()

    return this._isPresent(value)
  }

  /** @returns {Date | null} */
  start() {
    return this.readAttributeUnderscore("start")
  }

  /** @returns {boolean} */
  hasStart() {
    const value = this.start()

    return this._isPresent(value)
  }

  /** @returns {Date | null} */
  end() {
    return this.readAttributeUnderscore("end")
  }

  /** @returns {boolean} */
  hasEnd() {
    const value = this.end()

    return this._isPresent(value)
  }

  /** @returns {Date} */
  createdAt() {
    return this.readAttributeUnderscore("created_at")
  }

  /** @returns {boolean} */
  hasCreatedAt() {
    const value = this.createdAt()

    return this._isPresent(value)
  }

  /** @returns {Date} */
  updatedAt() {
    return this.readAttributeUnderscore("updated_at")
  }

  /** @returns {boolean} */
  hasUpdatedAt() {
    const value = this.updatedAt()

    return this._isPresent(value)
  }

  /** @returns {import("./stripe-coupon.js").default | null} */
  stripeCoupon() {
    return this._readBelongsToReflection({modelClass: StripeCoupon, reflectionName: "stripe_coupon"})
  }

  /** @returns {Promise<import("./stripe-coupon.js").default | null>} */
  loadStripeCoupon() {
    if (!("stripeCouponId" in this)) throw new Error("Foreign key method wasn't defined: stripeCouponId")

    const id = this.stripeCouponId()
    const ransack = {}

    ransack["stripe_id_eq"] = id

    return this._loadBelongsToReflection(
      {
        reflectionName: "stripe_coupon",
        model: this,
        modelClass: StripeCoupon
      },
      {ransack}
    )
  }

  /** @returns {Promise<import("./stripe-coupon.js").default | null>} */
  ensureStripeCouponLoaded() {
    return this.ensureAssociationLoaded("stripe_coupon")
  }

  /** @returns {import("./stripe-customer.js").default | null} */
  stripeCustomer() {
    return this._readBelongsToReflection({modelClass: StripeCustomer, reflectionName: "stripe_customer"})
  }

  /** @returns {Promise<import("./stripe-customer.js").default | null>} */
  loadStripeCustomer() {
    if (!("stripeCustomerId" in this)) throw new Error("Foreign key method wasn't defined: stripeCustomerId")

    const id = this.stripeCustomerId()
    const ransack = {}

    ransack["stripe_id_eq"] = id

    return this._loadBelongsToReflection(
      {
        reflectionName: "stripe_customer",
        model: this,
        modelClass: StripeCustomer
      },
      {ransack}
    )
  }

  /** @returns {Promise<import("./stripe-customer.js").default | null>} */
  ensureStripeCustomerLoaded() {
    return this.ensureAssociationLoaded("stripe_customer")
  }

  /** @returns {import("./stripe-subscription.js").default | null} */
  stripeSubscription() {
    return this._readBelongsToReflection({modelClass: StripeSubscription, reflectionName: "stripe_subscription"})
  }

  /** @returns {Promise<import("./stripe-subscription.js").default | null>} */
  loadStripeSubscription() {
    if (!("stripeSubscriptionId" in this)) throw new Error("Foreign key method wasn't defined: stripeSubscriptionId")

    const id = this.stripeSubscriptionId()
    const ransack = {}

    ransack["stripe_id_eq"] = id

    return this._loadBelongsToReflection(
      {
        reflectionName: "stripe_subscription",
        model: this,
        modelClass: StripeSubscription
      },
      {ransack}
    )
  }

  /** @returns {Promise<import("./stripe-subscription.js").default | null>} */
  ensureStripeSubscriptionLoaded() {
    return this.ensureAssociationLoaded("stripe_subscription")
  }
}
